import React, { Component } from 'react';
import { 
  Row, 
  Card, 
  CardBody, 
  Col, 
  Form, 
  Input, 
  Button, 
  FormGroup,
  Label,
  Badge
} from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";

class AdnimTodoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            todoItems: [
                { id: 1, title: "Grade Math Quizzes", description: "Complete grading for Class 2 Section C", isCompleted: false },
                { id: 2, title: "Parent Conference", description: "Meeting with Emma's parents at 4PM", isCompleted: true },
                { id: 3, title: "Prepare Lesson Plan", description: "Science lesson for next week", isCompleted: false }
            ],
            newTodo: {
                title: "",
                description: ""
            },
            editMode: false,
            editId: null,
            showAllItems: false // New state to control visibility of all items
        }
    }

    // Handle form input changes
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            newTodo: {
                ...prevState.newTodo,
                [name]: value
            }
        }));
    }

    // Add new todo item
    addTodoItem = (e) => {
        e.preventDefault();
        const { newTodo, todoItems, editMode, editId } = this.state;
        
        if (newTodo.title.trim() === "") return;

        if (editMode) {
            // Update existing todo
            const updatedItems = todoItems.map(item => 
                item.id === editId ? { ...item, title: newTodo.title, description: newTodo.description } : item
            );
            
            this.setState({
                todoItems: updatedItems,
                newTodo: { title: "", description: "" },
                editMode: false,
                editId: null
            });
        } else {
            // Add new todo
            const newItem = {
                id: todoItems.length > 0 ? Math.max(...todoItems.map(item => item.id)) + 1 : 1,
                title: newTodo.title,
                description: newTodo.description,
                isCompleted: false
            };
            
            this.setState({
                todoItems: [...todoItems, newItem],
                newTodo: { title: "", description: "" }
            });
        }
    }

    // Toggle completion status
    toggleComplete = (id) => {
        const updatedItems = this.state.todoItems.map(item => 
            item.id === id ? { ...item, isCompleted: !item.isCompleted } : item
        );
        this.setState({ todoItems: updatedItems });
    }

    // Start editing a todo item
    editTodoItem = (id) => {
        const todoToEdit = this.state.todoItems.find(item => item.id === id);
        if (todoToEdit) {
            this.setState({
                newTodo: { 
                    title: todoToEdit.title, 
                    description: todoToEdit.description 
                },
                editMode: true,
                editId: id
            });
        }
    }

    // Delete a todo item
    deleteTodoItem = (id) => {
        const updatedItems = this.state.todoItems.filter(item => item.id !== id);
        this.setState({ todoItems: updatedItems });
    }

    // Cancel edit mode
    cancelEdit = () => {
        this.setState({
            newTodo: { title: "", description: "" },
            editMode: false,
            editId: null
        });
    }

    // Toggle between showing all items or just the first two
    toggleShowAll = () => {
        this.setState(prevState => ({
            showAllItems: !prevState.showAllItems
        }));
    }

    render() {
        const { todoItems, newTodo, editMode, showAllItems } = this.state;
        
        // Get items to display based on showAllItems state
        const displayedItems = showAllItems ? todoItems : todoItems.slice(0, 2);
        const hasMoreItems = todoItems.length > 2;
        
        return (
            <React.Fragment>
                <Col lg={6}>
                    <Card>
                        <CardBody className="border-bottom">
                            <div className="d-flex align-items-center">
                                <h5 className="font-size-15 mb-1">Admin's Task List</h5>
                                <div className="ms-auto">
                                    <Badge color="success" className="me-2">
                                        {todoItems.filter(item => item.isCompleted).length} Completed
                                    </Badge>
                                    <Badge color="warning">
                                        {todoItems.filter(item => !item.isCompleted).length} Pending
                                    </Badge>
                                </div>
                            </div>
                        </CardBody>
                        
                        <CardBody>
                            <Form onSubmit={this.addTodoItem}>
                                <Row>
                                    <Col md={12} className="mb-3">
                                        <FormGroup>
                                            <Label for="todoTitle">Task Title</Label>
                                            <Input
                                                type="text"
                                                id="todoTitle"
                                                name="title"
                                                value={newTodo.title}
                                                onChange={this.handleInputChange}
                                                className="form-control"
                                                placeholder="Enter task title..."
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={12} className="mb-3">
                                        <FormGroup>
                                            <Label for="todoDescription">Description</Label>
                                            <Input
                                                type="textarea"
                                                id="todoDescription"
                                                name="description"
                                                value={newTodo.description}
                                                onChange={this.handleInputChange}
                                                className="form-control"
                                                placeholder="Enter task description..."
                                                rows="3"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="text-end mb-4">
                                    {editMode && (
                                        <Button 
                                            color="secondary" 
                                            type="button" 
                                            className="me-2"
                                            onClick={this.cancelEdit}
                                        >
                                            Cancel
                                        </Button>
                                    )}
                                    <Button 
                                        color="primary" 
                                        type="submit"
                                    >
                                        {editMode ? "Update Task" : "Add Task"}
                                    </Button>
                                </div>
                            </Form>
                            
                            <div className="todo-list">
                                {/* Header */}
                                <div className="d-flex align-items-center mb-3">
                                    <h6 className="font-size-14 mb-0">Tasks</h6>
                                </div>
                            
                                <SimpleBar style={{ maxHeight: "250px" }}>
                                    {displayedItems.length > 0 ? (
                                        displayedItems.map((item) => (
                                            <div 
                                                key={item.id} 
                                                className={`todo-item p-3 rounded mb-2 ${item.isCompleted ? 'bg-light' : 'bg-white'}`}
                                                style={{ border: "1px solid #e9e9ef" }}
                                            >
                                                <div className="d-flex align-items-start">
                                                    <div className="me-3">
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`todo-${item.id}`}
                                                                checked={item.isCompleted}
                                                                onChange={() => this.toggleComplete(item.id)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h5 className={`font-size-14 mb-1 ${item.isCompleted ? 'text-decoration-line-through' : ''}`}>
                                                            {item.title}
                                                        </h5>
                                                        <p className={`text-muted mb-0 ${item.isCompleted ? 'text-decoration-line-through' : ''}`}>
                                                            {item.description}
                                                        </p>
                                                    </div>
                                                    <div className="ms-auto">
                                                        <Button
                                                            color="light"
                                                            size="sm"
                                                            className="me-1"
                                                            onClick={() => this.editTodoItem(item.id)}
                                                        >
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Button>
                                                        <Button
                                                            color="light"
                                                            size="sm"
                                                            onClick={() => this.deleteTodoItem(item.id)}
                                                        >
                                                            <i className="mdi mdi-trash-can"></i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center py-4">
                                            <p className="text-muted mb-0">No tasks added yet</p>
                                        </div>
                                    )}
                                </SimpleBar>

                                {/* View More button placed below the tasks */}
                                {hasMoreItems && (
                                    <div className="text-end mt-3">
                                        <button 
                                            className="btn btn-link text-primary p-0" 
                                            onClick={this.toggleShowAll}
                                        >
                                            {showAllItems ? 'View Less' : `View More (${todoItems.length - 2})`}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        );
    }
}

export default AdnimTodoList;